import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, getBatchFetcher } from '~/api/utils'

export type OrderClientHead = {
  id: number
  jobTitle?: string
  status: number
  statusDetail: number
}

const orderHeadBatcher = <T extends OrderClientHead>(
  additionalFields: string[]
) =>
  getBatchFetcher<T>(`orderHead_${additionalFields.join('_')}`, async (ids) => {
    return await fetchApiWithToken<T[]>({
      method: 'get',
      url: `/v1/orders?id[]=${ids.join('&id[]=')}&itemsPerPage=1000&fields[]=id&fields[]=jobTitle&fields[]=status&fields[]=statusDetail${additionalFields.length > 0 ? `&fields[]=${additionalFields.join('&fields[]=')}` : ''}`
    })
  })

export function useOrderHead<T extends OrderClientHead>({
  orderId,
  additionalFields
}: {
  orderId?: number
  additionalFields?: string[]
}) {
  return useQuery({
    queryKey: ['orders', 'head', orderId, additionalFields],
    queryFn: () =>
      orderHeadBatcher<T>(additionalFields ?? []).fetch(orderId as number),
    enabled: !!orderId,
    staleTime: 300_000
  })
}
